<div (focusout)="submit($event, element.value)">
	<input #element type="text" [value]="init" (keyup.enter)="submit($event, element.value)" />
	<app-icon #cancelIcon name="sluiten" size="small" color="primary-1" hoverColor="secondary-1" (mousedown)="cancel()" (touchstart)="cancel()"></app-icon>
</div>
